let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kt0sJ")).then(() => parcelRequire('lRQj5'));